// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { AllowlistNormalizedEntry } from '../models/AllowlistNormalizedEntry';
import { HttpFile } from '../http/http';

export class DistributionNormalized {
    'card_id': number;
    'contract': string;
    'wallet': string;
    'wallet_display': string;
    'card_name'?: string | null;
    'mint_date'?: Date | null;
    'airdrops': number;
    'total_spots': number;
    'total_count': number;
    'minted': number;
    'allowlist'?: Array<AllowlistNormalizedEntry> | null;
    'phases'?: Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "card_id",
            "baseName": "card_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "wallet",
            "baseName": "wallet",
            "type": "string",
            "format": ""
        },
        {
            "name": "wallet_display",
            "baseName": "wallet_display",
            "type": "string",
            "format": ""
        },
        {
            "name": "card_name",
            "baseName": "card_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "mint_date",
            "baseName": "mint_date",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "airdrops",
            "baseName": "airdrops",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total_spots",
            "baseName": "total_spots",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total_count",
            "baseName": "total_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "minted",
            "baseName": "minted",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "allowlist",
            "baseName": "allowlist",
            "type": "Array<AllowlistNormalizedEntry>",
            "format": ""
        },
        {
            "name": "phases",
            "baseName": "phases",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return DistributionNormalized.attributeTypeMap;
    }

    public constructor() {
    }
}
